<template>
  <div>
    <fr-dropdown class="pe-2">
      <fr-dropdown-heading
        auto-caret
        auto-close="outside"
        class="rounded d-flex align-items-center text-white border-none p-2"
        style="max-width: 160px !important"
      >
        <div class="text-start text-truncate" style="max-width: 90% !important; min-height: 20px;cursor: pointer;">
          {{ selectedBrandMerchants.find(e => selectedMerchants[0] == e.id)?.name }}
        </div>
      </fr-dropdown-heading>

      <fr-dropdown-group style="max-height: 50vh; min-height: 200px; overflow-y: auto;padding-top: 0px; width: 330px">
        <div class="sticky-top bg-white p-2">
          <input class="form-control" placeholder="Search..." v-model="searchBrandName">
        </div>
        <fr-dropdown-options
          v-for="merchant in filteredMerchants"
          :key="merchant.id"
          :class="merchant.id == selectedMerchants[0] ? 'bg-purple' : ''"
          @click="selectedMerchantIds([merchant.id])"
          class="w-100 text-truncate"
        >
          {{ merchant.name }}
        </fr-dropdown-options>
      </fr-dropdown-group>
    </fr-dropdown>
  </div>
</template>
<script>
import {
  FrDropdown,
  FrDropdownHeading,
  FrDropdownGroup,
  FrDropdownOptions,
} from "@froogal.ai/ui";
import { storeToRefs } from "pinia";
import { useBrandsStore } from "@/stores/brands";
import { useMerchantsStore } from "@/stores/merchants"
import Fuse from "fuse.js";
export default {
  name: "loyalty-picker",
  setup() {
    const brands = useBrandsStore();
    const { selectedBrandId } = storeToRefs(brands);
    const merchantList = useMerchantsStore();
    const { selectedBrandMerchants, selectedMerchants } =
      storeToRefs(merchantList);
    const { selectedMerchantIds } = merchantList;
    return {
      selectedBrandId,
      selectedBrandMerchants,
      selectedMerchants,
      selectedMerchantIds,
    };
  },
  watch: { 
    selectedBrandMerchants() {
      this.selectFirstMerchant()
    }
  },
  data() {
    return {
      searchBrandName: ''
    }
  },
  mounted() {
    this.selectFirstMerchant()
  },
  computed: {
    filteredMerchants: function () {
      if (this.searchBrandName) {
        const fuse = new Fuse(this.selectedBrandMerchants, {
          keys: ['name'],
          threshold: 0.4, // Adjust this threshold as needed
        });
        return fuse.search(this.searchBrandName).map(result => result.item);
      }
      return this.selectedBrandMerchants;
    },
  },
  methods: {
    selectFirstMerchant() {
      if(this.selectedBrandMerchants.length && !this.selectedMerchants[0]) {
        this.selectedMerchantIds([this.selectedBrandMerchants[0]?.id])
      }
    }
  },
  components: {
    FrDropdown,
    FrDropdownGroup,
    FrDropdownHeading,
    FrDropdownOptions,
  }
};
</script>
